// สูตรราคาคอยน์/สิทธิ์สร้างตัวละคร (ฟังก์ชันล้วน ไม่แตะ DB) — ใช้ทั้งฝั่งยืนยันยอด (economy.js) และหน้าเว็บ (แสดงสดตอนกรอก)
//  ค่าทั้งหมดมาจาก settings ใน DB (แอดมินแก้ได้) ; รูปแบบขั้น = "ขั้นต่ำ:เปอร์เซ็นต์,..." เช่น "500:10,1000:20"

/** "500:10,1000:20" -> [{min:500,pct:10},{min:1000,pct:20}] เรียงน้อย->มาก ; ข้ามรายการที่ไม่ถูกต้อง */
export function parseTiers(s) {
  if (Array.isArray(s)) return s; // ผ่านการแปลงแล้ว (pricing.get ส่งเป็นอาร์เรย์ให้หน้าเว็บ)
  return String(s === undefined || s === null ? "" : s)
    .split(",")
    .map((x) => x.trim().split(":"))
    .map(([a, b]) => ({ min: Number(a), pct: Number(b) }))
    .filter((t) => isFinite(t.min) && isFinite(t.pct) && t.min > 0 && t.pct >= 0 && t.pct <= 100)
    .sort((a, b) => a.min - b.min);
}

/** เปอร์เซ็นต์ของขั้นสูงสุดที่ถึง (ไม่ถึงขั้นไหน = 0) */
export const tierPct = (tiers, n) => tiers.reduce((p, t) => (n >= t.min ? t.pct : p), 0);

const isInt = (n) => typeof n === "number" && isFinite(n) && Math.floor(n) === n;

/** เติมคอยน์: คอยน์ = บาท x อัตรา + โบนัสตามช่วงที่ถึง ; ok=false + reason เมื่อยอดไม่ถูกต้อง */
export function coinCalc(amount, cfg) {
  const baht = Number(amount);
  const min = Number(cfg.min), max = Number(cfg.max);
  if (!isInt(baht)) return { ok: false, reason: "ยอดเติมต้องเป็นจำนวนเต็ม (บาท)", baht };
  if (baht < min || baht > max) return { ok: false, reason: `ยอดเติมต้องอยู่ระหว่าง ${min.toLocaleString("en-US")}–${max.toLocaleString("en-US")} บาท`, baht };
  const base = baht * Number(cfg.perBaht);
  const bonusPercent = tierPct(parseTiers(cfg.bonusTiers), baht);
  const bonus = Math.round((base * bonusPercent) / 100);
  return { ok: true, baht, base, bonusPercent, bonus, coins: base + bonus, vipPoints: baht };
}

/** สิทธิ์สร้างตัวละคร: ราคา = จำนวน x ราคาต่อตัว ลดตามขั้นที่ถึง ปัดเป็นบาทเต็ม */
export function creditCalc(qty, cfg) {
  const n = Number(qty);
  const max = Number(cfg.max);
  if (!isInt(n) || n < 1) return { ok: false, reason: "จำนวนต้องเป็นจำนวนเต็มอย่างน้อย 1 ตัว", qty: n };
  if (n > max) return { ok: false, reason: `ซื้อได้สูงสุด ${max} ตัวต่อครั้ง`, qty: n };
  const unit = Number(cfg.price);
  const discountPercent = tierPct(parseTiers(cfg.tiers), n);
  const gross = n * unit;
  const price = Math.round((gross * (100 - discountPercent)) / 100);
  return { ok: true, qty: n, unit, discountPercent, gross, price, saved: gross - price };
}

/** ตัวเลือกสำเร็จรูปของแพ็กสร้างตัวละคร = ทุกขั้นในตั้งค่า (ไม่มีขั้น 1 ให้เติม 1 ตัวไว้ต้นรายการ) */
export function creditPresets(cfg) {
  const sizes = parseTiers(cfg.tiers).map((t) => t.min).filter((n) => n <= Number(cfg.max));
  if (sizes.indexOf(1) === -1) sizes.unshift(1);
  return sizes.map((n) => creditCalc(n, cfg));
}
